import { useAction, useAtom, useCtx } from '@reatom/npm-react'
import { useEffect, useRef } from 'react'

import {
  Deeplink,
  DeeplinkHandler,
  openDeeplinkDialogAction,
} from '@root/entities/deeplinking'
import { selectedNetworkAtom } from '@root/entities/network'
import { joinedInviteCodeAtom } from '@root/entities/referral'
import { handleGoogleAuthDeeplinkAction } from '@root/features/auth/google'
import { handleTelegramAuthDeeplinkAction } from '@root/features/auth/telegram'
import { handleTwitterAuthDeeplinkAction } from '@root/features/auth/twitter/atoms'
import { onInitializationReadyAction } from '@root/features/initialization/atoms/common'
import { checkCurrencyReatom } from '@root/features/premium/check-currency'
import { useAppRoutes } from '@root/features/routing'
import { settingScreenAction } from '@root/features/settings/settings-screen/atoms'
import { PlatformUtil } from '@root/shared'

// ????
export const deeplinkBuyPremiumFlowModel = checkCurrencyReatom(undefined, {
  name: 'deeplinkBuyPremiumFlow',
})

// Should it be inside react? can we move to reatom?
export const useDeeplinkHandlers = () => {
  const ctx = useCtx()

  const appRoutes = useAppRoutes()
  const [_selectedNetwork, setSelectedNetwork] = useAtom(selectedNetworkAtom)

  const checkCurrency = useAction(
    deeplinkBuyPremiumFlowModel.checkCurrencyAction,
  )

  const openDeeplinkDialog = useAction(openDeeplinkDialogAction)

  const deeplinkServiceRef = useRef(
    new DeeplinkHandler(
      Deeplink.match({
        Homepage: async (deeplink) => {
          appRoutes.navigateToRoot()

          if (PlatformUtil.is('browser')) {
            openDeeplinkDialog({ deeplink })
          }
        },
        Profile: async (deeplink) => {
          if (PlatformUtil.is('browser')) {
            appRoutes.navigateToRoot() // to root — profile is protected
            openDeeplinkDialog({ deeplink })
          } else {
            appRoutes.navigateToProfileIndex()
          }
        },
        InviteCodeJoin: async (deeplink) => {
          joinedInviteCodeAtom(ctx, deeplink.inviteCode)

          if (PlatformUtil.is('browser')) {
            appRoutes.navigateToRoot() // to root — register is protected
            openDeeplinkDialog({ deeplink })
          }
        },
        UserProfile: async (deeplink) => {
          appRoutes.navigateUserProfile(deeplink.delugeId)
        },
        Trade: async (deeplink) => {
          appRoutes.navigateToTrading(deeplink.pair, deeplink.network)
          if (PlatformUtil.is('browser')) {
            openDeeplinkDialog({ deeplink })
          }
        },
        TelegramAuth: async (deeplink) => {
          // Signing in happens here on every platform now. The web used to
          // be offered the desktop app instead, which is no use to somebody
          // who came from the bot to trade in their browser.
          handleTelegramAuthDeeplinkAction(ctx, deeplink)
          if (PlatformUtil.is('browser')) {
            appRoutes.navigateToRoot() // to root — user profile is protected
          }
        },
        GoogleAuth: async (deeplink) => {
          if (PlatformUtil.is('browser')) {
            appRoutes.navigateToRoot() // to root — user profile is protected
            openDeeplinkDialog({ deeplink })
          } else {
            handleGoogleAuthDeeplinkAction(ctx, deeplink)
          }
        },
        TwitterAuth: async (deeplink) => {
          if (PlatformUtil.is('browser')) {
            appRoutes.navigateToRoot() // to root — user profile is protected
            openDeeplinkDialog({ deeplink })
          } else {
            handleTwitterAuthDeeplinkAction(ctx, deeplink)
          }
        },
        Nft: async () => appRoutes.navigateToNft(),
        CheckCurrency: async (deeplink) => {
          if (PlatformUtil.is('browser')) {
            openDeeplinkDialog({ deeplink })
            return
          }

          onInitializationReadyAction(ctx, () => {
            setSelectedNetwork(deeplink.network)
            checkCurrency({ address: deeplink.queryAddress })
          })
        },
      }),
    ),
  )

  useEffect(() => {
    const hostPlatform = PlatformUtil.hostPlatform()
    if (hostPlatform) {
      document.documentElement.setAttribute('data-platform', hostPlatform)
    }

    window.__OPEN_SETTINGS__ = () => settingScreenAction(ctx, 'main')

    const deeplinkHandler = deeplinkServiceRef.current
    deeplinkHandler.run()

    return () => deeplinkHandler.stop()
  }, [ctx])

  return
}
